import { svg } from 'lit';

const symbol = svg`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="6.833" stroke="currentcolor"/><path stroke="currentcolor" d="M8 7v5.5"/><circle cx="8" cy="4.75" r=".75" fill="currentcolor"/></svg>`;

export { symbol as default };
